import { render, staticRenderFns } from "./EnquiryServicesComponent.vue?vue&type=template&id=78a8fd5d"
import script from "./EnquiryServicesComponent.vue?vue&type=script&lang=ts"
export * from "./EnquiryServicesComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports